import { useMemo } from "react";

const labels = {
  English: {
    AgencyPartners: "Agency Partners",
    ManageAndTrack: "Manage and track your agency partners through the system.",
    SearchAgency: "Search agency...",
    AgencyPartnersList: "Agency Partners List",
    Overview: "Overview of all agency partners in the system",
    AgencyName: "Agency Name",
    Email: "Email",
    ContactNo: "Contact No",
    Status: "Status",
    Actions: "Actions",
    NoAgencyFound: "No agency partners found",
    ViewDetails: "View Details",
    Edit: "Edit",
    Delete: "Delete",
    Pending: "Pending",
    Accepted: "Accepted",
    Reject: "Reject",
    AcceptanceRejectionRates: "Agency Overview",
    RatesOverview: "All accepted and rejected agencies",
    AcceptedAgencies: "Accepted Agencies",
    RejectedAgencies: "Rejected Agencies",
    AddAgency: "Add Agency",
    AgencyPartnerDetails: "Agency Partner's Details",
    AgencyId: "Agency ID:",
    Name: "Name",
    DateAdded: "Date Added",
    NA: "N/A",
    Loading: "Loading...",
    EditAgency: "Edit Agency",
    UpdateDetails: "Update the details of the agency partner below.",
    UpdateAgency: "Update Agency",
    AddNewAgency: "Add a new agency partner to the system.",
    Add: "Add Agency",
    Save: "Save",
    Discard: "Discard",
    DeleteConfirmation:
      "Warning: This action cannot be undone. Are you sure you want to permanently delete this agency partner? All associated records will be permanently removed from the system.",
    Yes: "Yes",
    No: "No",
  },
  Japanese: {
    AgencyPartners: "代理店パートナー",
    ManageAndTrack: "システムを通じて代理店パートナーを管理および追跡します。",
    SearchAgency: "代理店を検索...",
    AgencyPartnersList: "代理店パートナー一覧",
    Overview: "システム内のすべての代理店パートナーの概要",
    AgencyName: "代理店名",
    Email: "メール",
    ContactNo: "連絡先",
    Status: "状態",
    Actions: "操作",
    NoAgencyFound: "代理店パートナーが見つかりません",
    ViewDetails: "詳細を見る",
    Edit: "編集",
    Delete: "削除",
    Pending: "保留中",
    Accepted: "承認済み",
    Reject: "拒否",
    AcceptanceRejectionRates: "代理店概要",
    RatesOverview: "すべての承認および拒否された代理店",
    AcceptedAgencies: "承認された代理店",
    RejectedAgencies: "拒否された代理店",
    AddAgency: "代理店を追加",
    AgencyPartnerDetails: "代理店パートナーの詳細",
    AgencyId: "代理店ID:",
    Name: "名前",
    DateAdded: "追加日",
    NA: "該当なし",
    Loading: "読み込み中...",
    EditAgency: "代理店を編集",
    UpdateDetails: "以下の代理店パートナーの詳細を更新してください。",
    UpdateAgency: "代理店を更新",
    AddNewAgency: "システムに新しい代理店パートナーを追加します。",
    Add: "代理店を追加",
    Save: "保存",
    Discard: "破棄",
    DeleteConfirmation:
      "警告：この操作は取り消すことができません。この代理店パートナーを完全に削除してもよろしいですか？関連するすべての記録がシステムから完全に削除されます。",
    Yes: "はい",
    No: "いいえ",
  },
};

export const useLabels = (language = "English") => {
  const currentLabels = useMemo(() => {
    return labels[language] || labels.English;
  }, [language]);

  return {
    labels: currentLabels,
  };
};
